<template>
  <div id="app">
    <Index />
  </div>
</template>

<script>
import Index from "./view/index.vue";

export default {
  name: "App",
  components: {
    Index,
  },
};
</script>

<style lang="scss" scoped>

body {
  font-family: LarkEmojiFont, LarkChineseQuote, -apple-system,
    BlinkMacSystemFont, Helvetica Neue, Tahoma, PingFang SC, Microsoft Yahei,
    Arial, Hiragino Sans GB, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol, Noto Color Emoji;
  height: 100%;
  -webkit-font-variant-ligatures: no-common-ligatures;
  font-variant-ligatures: no-common-ligatures;
  -webkit-print-color-adjust: exact;
  width: 100%;
}

</style>
